import Drawer from "@mui/material/Drawer/Drawer";
import { FC, useEffect, useState } from "react";
import { FormProvider, useForm } from 'react-hook-form';
import FormControl from "@mui/material/FormControl/FormControl";
import FormLabel from "@mui/material/FormLabel/FormLabel";
import RadioGroup from "@mui/material/RadioGroup/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel/FormControlLabel";
import Radio from "@mui/material/Radio/Radio";
import CustomSelect, { IOptions } from "../../components/FormFields/CustomSelect";
import { fetchRoles } from "../../store/rolesThunk";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { Box, Button, DialogActions, DialogContent, DialogTitle, Grid, SelectChangeEvent, Typography } from '@mui/material';
import LoadingButton from "@mui/lab/LoadingButton/LoadingButton";
import { ApiStatus } from "../../utils/api.types";
import { updateUserInvite, fetchUsers, updateUser, fetchUserById } from "../../store/userThunk";

interface userEdit {
    status: string;
    role: string;
};

interface DialogAddressFormProps {
    title?: string;
    userRow?: any;
    open: boolean;
    onClose: (k: any) => void;
};

const UserEditDrawer: FC<DialogAddressFormProps> = ({ title, onClose, userRow, open }) => {

    const [userRoles, setUserRoles] = useState<IOptions[]>(
        []
    );
    const { status } = useAppSelector((state) => state.users);
    const dispatch = useAppDispatch();
    const [userInviteStatus, setUserInviteStatus] = useState('');
    const [userRoleValues, setUserRoleValues] = useState(userRow?.role?.role);

    useEffect(() => {
			const getRoles = async () => {
        const data: any = await dispatch(fetchRoles());
        setUserRoles(data.payload.map((c: any) => {
            return { label: c.role, value: c._id }
        }));
			};
			(getRoles());
    }, [dispatch]);

    useEffect(() => {
       
        setUserInviteStatus(userRow?.isActive === true ? 'Active' : 'Inactive');
        setUserRoleValues(userRow?.role?._id);
    }, [open, userRow]);

    const methods = useForm<userEdit>({
        mode: "all",
        shouldUnregister: true
    });
    const { register } = methods;

    const closeDialog = () => {
        onClose('');
    };
    const handleRadioButtons = (e: any) => {
        setUserInviteStatus(e.target.value);
    }

    const onSubmit = async (data: any) => {
        try {
            let userStatus = userInviteStatus === 'Active' ? true : false;
            await dispatch(updateUserInvite({ userId: userRow._id, accountId: userRow.accountId, userUpdatePayload: { isUserVerified: userStatus,role: userRoleValues } })).unwrap();
            closeDialog();
            // Show the updated value in the list                
            dispatch(fetchUsers(userRow.accountId)); 
        } catch (error: any) {
            // Empty catch block.
        }
    };

    return (
        <Drawer anchor="right" open={open}>
            <Box>
                <div className="drawer-form-container">
                    <FormProvider {...methods}>
                        <DialogTitle>
                            <Box sx={{ display: "flex", mt: 2, justifyContent: "space-between" }}>
                                <Typography variant="h5">Edit Member</Typography>
                            </Box>
                        </DialogTitle>
                        <DialogContent>
                            <Grid container justifyContent="center" spacing={2} rowSpacing={-2}>
                                <Grid item xs={12} md={12} sm={12} lg={12}>
                                    <FormControl>
                                        <FormLabel id="status-label">Status</FormLabel>
                                        <RadioGroup
                                            {...register("status")}
                                            row
                                            onChange={handleRadioButtons}                                      
                                            value={userInviteStatus}
                                            name="status">
                                            <FormControlLabel value="Active" style={{ margin: '0px 10px' }} control={<Radio  checked={userInviteStatus === 'Active'}/>} label="Active" />
                                            <FormControlLabel value="Inactive" style={{ margin: '0px 10px' }} control={<Radio checked={userInviteStatus === 'Inactive'} />} label="Inactive" />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={12} sm={12} lg={12}>

                                    <CustomSelect
                                        name="role"
                                        label="Role"
                                        id="user-role"
                                        variant="standard"
                                        options={userRoles}
                                        value={userRoleValues ?? ""}
                                        onChange={(event: SelectChangeEvent<any>) => {
                                            // let sRole = userRoles.filter(f1 => f1.value == event.target.value)[0];
                                            // let aOptions: IOptions[] = [{ "label": event.target.name, "value": event.target.value }];
                                            setUserRoleValues(event.target.value);
                                        }} />

                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Grid container display="flex" justifyContent="flex-end" gap={0} sx={{ width: '100%', pt: '10px', position: 'absolute', bottom: '0px', mb: '30px', mr:'15px' }}>
                               
                                <Grid item xs={12} md={12} sm={12} lg={12} display="flex" justifyContent="flex-end" >
                                    <Button variant='outlined'
                                        style={{ marginRight: '10px' }}
                                        onClick={() => {
                                            methods.reset();
                                            onClose(false);
                                        }}>Cancel</Button>
                                    <LoadingButton
                                        type="submit"
                                        onClick={methods.handleSubmit(onSubmit)}
                                        loading={status === ApiStatus.LOADING}
                                        variant="contained">
                                        Save
                                    </LoadingButton>
                                </Grid>
                            </Grid>
                        </DialogActions>

                    </FormProvider>
                </div>
            </Box>
        </Drawer>
    );
}
export default UserEditDrawer;